﻿import {useMemo} from "react";
import {useReactiveGetRequest} from "../request/useReactiveGetRequest";
import {AccountType} from "../../components/constants/securspace-constants";

interface UseGetAdminCompanyNames {
  accountType?: typeof AccountType.SUPPLIER | typeof AccountType.BUYER;
}

/**
 * Company name object returned by the API
 */
export interface AdminCompanyNameVO {
  id: string;
  companyName: string;
}

const useGetAdminCompanyNames = ({accountType}: UseGetAdminCompanyNames) => {
  const queryParams = useMemo(() => ({
    type: accountType ? [accountType] : [AccountType.SUPPLIER, AccountType.BUYER],
  }), [ accountType ]);

  const {
    data: adminCompanyNames,
    isLoading,
    error // todo yf change requestUrl to constant when branch is merged: story/1637-implement-filtering-ui-logic-for-admin-accounts-pages---wi00938533-v2
  } = useReactiveGetRequest<AdminCompanyNameVO[]>({ requestUrl: '/api/admins/account/company-names', queryParams });

  return {
    adminCompanyNames,
    isLoading,
    error,
  }
}

export { useGetAdminCompanyNames };
